import React from 'react'
function NavRightArrow({ color = 'dark' }) {
   return (
      <>
         {color === 'dark' ? (
            <svg
               height="19"
               width="36"
               viewBox="0 0 36 19"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <path
                  d="M35.766 9.15325L27.5843 0.971548C27.2904 0.628359 26.7739 0.588352 26.4307 0.882323C26.0876 1.17622 26.0475 1.69273 26.3415 2.03592C26.369 2.06798 26.3987 2.09772 26.4307 2.12514L33.2133 8.91595H0.822048C0.370228 8.91595 0.00390625 9.28227 0.00390625 9.73416C0.00390625 10.186 0.370228 10.5523 0.822048 10.5523H33.2133L26.4307 17.3349C26.0876 17.6288 26.0475 18.1453 26.3415 18.4885C26.6355 18.8317 27.1519 18.8717 27.4951 18.5777C27.5272 18.5502 27.5569 18.5205 27.5843 18.4885L35.766 10.3068C36.0832 9.98777 36.0832 9.47239 35.766 9.15325Z"
                  fill="#1F473E"
               />
            </svg>
         ) : (
            <svg
               width="37"
               height="19"
               viewBox="0 0 37 19"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <path
                  d="M36.2171 9.29436L28.0355 1.11266C27.7416 0.769472 27.2251 0.729465 26.8819 1.02344C26.5387 1.31734 26.4987 1.83384 26.7927 2.17703C26.8202 2.2091 26.8499 2.23884 26.8819 2.26626L33.6645 9.05706H1.27322C0.8214 9.05706 0.455078 9.42338 0.455078 9.87527C0.455078 10.3272 0.8214 10.6934 1.27322 10.6934H33.6645L26.8819 17.476C26.5387 17.7699 26.4987 18.2864 26.7927 18.6296C27.0867 18.9728 27.6031 19.0128 27.9463 18.7188C27.9783 18.6913 28.0081 18.6616 28.0355 18.6296L36.2172 10.4479C36.5344 10.1289 36.5344 9.6135 36.2171 9.29436Z"
                  fill="#F1ECDC"
               />
            </svg>
         )}
      </>
   )
}
export default NavRightArrow
